import MyShops from '@/pages/MyShops'

export default {
    path: '/myshops',
    name: 'MyShops',
    component: MyShops
}


// WEBPACK FOOTER //
// ./src/router/myshops.js